import { useContext } from "react";
import { PspContext } from "../../../config/contexts";

export function useNavbarMobile() {
  const { lang, selectedMandate, user } = useContext(PspContext);

  const hasAttendances = selectedMandate?.hasAttendances ?? false;

  const isPrivilegedUser =
    user?.scopes.includes("admin") ||
    user?.scopes.includes("super_employee") ||
    user?.scopes.includes("employee");

  const right =
    user && selectedMandate
      ? user.mandateRights.find((r) => r.mandate.id === selectedMandate.id)
          ?.right
      : undefined;
  const hasUploadTab =
    right?.allowedTabs.includes("UPLOAD") || isPrivilegedUser;
  const hasDocumentsTab =
    right?.allowedTabs.includes("PSP_DOCUMENTS") ||
    right?.allowedTabs.includes("SUBMITTED_DOCUMENTS") ||
    isPrivilegedUser;

  return { lang, hasAttendances, hasUploadTab, hasDocumentsTab };
}
